import { createFileRoute, Link } from "@tanstack/react-router";
import { ExperimentHeader } from "@charphq/ui/components/experiments";
import { EXPERIMENTS } from "../lib/experiments";

/**
 * The gallery: one card per experiment.
 *
 * Also the landing page for the nav group, so it has to stand on its own —
 * someone who clicks "Experiments" and expands nothing should still know what
 * is in here.
 */
export const Route = createFileRoute("/experiments/")({
  component: ExperimentsGallery,
});

function ExperimentsGallery() {
  return (
    <div className="flex flex-col gap-6">
      <ExperimentHeader
        title="Experiments"
        subtitle="Exploratory views over the monitored collections. Everything here runs on a synthetic dataset — no customer data is shown."
      />

      <ul className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {EXPERIMENTS.map((experiment) => {
          const Icon = experiment.icon;
          return (
            <li key={experiment.slug}>
              <Link
                to={experiment.href}
                className="flex h-full flex-col gap-3 rounded-xl border border-border bg-card p-5 shadow-xs transition-colors hover:border-brand-blue/30 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <span className="flex items-center gap-2.5">
                  <Icon className="h-5 w-5 shrink-0 text-brand-blue" aria-hidden="true" />
                  <span className="font-display text-base font-semibold">{experiment.title}</span>
                </span>
                <span className="font-sans text-[13px] leading-relaxed text-muted-foreground">
                  {experiment.subtitle}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
